import { RecordingScreen } from 'component/navigation/recording-screen';
import { useLocalSearchParams } from 'expo-router';
import { ParamProvider } from 'util/params';

export default function SpaceRecordingScreen() {
    const { recordingId1 } = useLocalSearchParams<{ recordingId1: string }>();
    return (
        <ParamProvider screenParams={{ recordingId: recordingId1 }}>
            <RecordingScreen />
        </ParamProvider>
    );
}
